var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{attrs:{"title":_vm.title}},[_c('dd',{staticClass:"mt-1 text-3xl font-semibold text-gray-900"},[_vm._v(" "+_vm._s(_vm.value || "...")+" "),_c('span',{staticClass:"text-sm text-gray-500"},[_vm._v("Mbit/s")])])])}
var staticRenderFns = []

export { render, staticRenderFns }